<template>
    <div
        v-if="initialized"
        class="overflow-hidden">
        <div class="flex w-full h-full overflow-hidden gap-2 mb-2">
            <div class="w-1/2 max-h-[800px] flex flex-col">
                <div class="space-x-2 flex-none">
                    <driver-info :drivers="drivers" />
                    <vehicle-info :vehicles="vehicles" />
                </div>
                <travel-route-info
                    class="flex-1"
                    :travel-details="travelDetails" />
            </div>
            <div class="w-1/2 max-h-[800px]">
                <div class="h-[800px]">
                    <hts-map-route
                        v-if="visibleMap"
                        ref="map"
                        center-marker
                        :route="markers"
                        :route-separated="routes"
                        :draggable="false"
                        :show-location="showLocation"
                        :lat-lng-location-routes="CLatLngLocationRoutes">
                        <template #top>
                            <div class="flex min-h-5 justify-end gap-3">
                                <hts-map-icon-location />
                            </div>
                        </template>
                    </hts-map-route>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import DriverInfo from './driver-info.vue'
import VehicleInfo from './vehicle-info.vue'
import TravelRouteInfo from './travel-route-info.vue'
import routeMap from '@/pages/trucker-[id]/route/ignore/route-map'

const { markers, setMarkers, routes, setRoutes, setRoutingPositions, showLocation, CLatLngLocationRoutes } = routeMap()
const initialized = ref(false)
const visibleMap = ref(false)
const props = defineProps({
  trip: {
    type: Object,
    required: true
  }
})

const { trip } = toRefs(props)
const journeys = computed(() => trip.value?.journeys || [])
const vehicles = computed(() => journeys.value.map((j: any) => j.vehicle || j.vehicleTemp))
const drivers = computed(() => vehicles.value.map((v: any) => v?.driver))
const travelDetails = computed(() => trip.value?.travelDetails || [])

onMounted(() => {
  nextTick(() => {
    initialized.value = true
    visibleMap.value = true
    nextTick(() => {
      show(trip.value)
    })
  })
})
const show = (trip: any) => {
  if (trip.routingPositions) {
    setRoutingPositions(trip.routingPositions)
    setMarkers(trip.positions, {
      renderMarkerByIndexNumber: true
    })
    setRoutes(trip.positions, {
      renderMarkerByIndexNumber: true
    })
  }
}

const close = () => {}

defineExpose({
  show,
  close
})
</script>
